<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
<dash-gis-flexible-panel [panelTitle]="reportTitle$ | async"
  [width]="panelWidth$ | async"
  [enableResize]="true"
  [enableScroll]="!(shouldDisableScroll$ | async)"
  [disableHistory]="isHistoryEmpty$ | async"
  (panelBack)="historyBack()"
  (resizeEnd)="onResizeEnd($event)"
  (closePanel)="closePanel.emit()">
  <div class="report-box" fxLayout="column" fxFlex>
    @if (activeFeatureReports$ | async; as activeReports) {
      <div
        fxLayout="column" fxFlex>
        @if (activeLayers$ | async; as activeLayers) {
          <!-- multiple layers -->
          @if (activeLayers.length > 1) {
            <dash-gis-report-side-tabs
              [featureReports]="activeReports"
              [uid]="uid"
              (activeLayer)="setActiveLayer($event)"
              (recordCount)="setRecordCount($event)"
              (reportTitle)="setReportTitle($event)"
              (overrideSubtype)='setSubtype($event)'
              (widthUpdate)="onWidthUpdate($event)"
            fxLayout="column" fxFlex></dash-gis-report-side-tabs>
          }
          @if (activeLayers.length === 1) {
            <div fxLayout="column" fxFlex>
              <!-- multiple reports: single layer or data -->
              @if (activeReports[activeLayers[0]].length > 1) {
                <dash-gis-report-selector
                  fxLayout="column" fxFlex="1 1 auto"
                  class="xyz"
                  [reportType]="'feature'"
                  [launchOptions]="activeReports[activeLayers[0]]"
                  [uid]="uid"
                  (recordCount)="setRecordCount($event)"
                  (widthUpdate)="onWidthUpdate($event)"
                (reportTitle)="setReportTitle($event)"></dash-gis-report-selector>
              }
              <!-- single layer, single report -->
              @if (activeReports[activeLayers[0]].length === 1) {
                <dash-gis-feature-report
                  fxFlex fxLayout="column"
                  [showControls]="true"
                  [launchOptions]="activeReports[activeLayers[0]][0]"
                  [uid]="uid"
                  (recordCount)="setRecordCount($event)"
                  (overrideSubtype)="setSubtype($event)"
                  (reportTitle)="setReportTitle($event)"
                  (widthUpdate)="onWidthUpdate($event)"
                ></dash-gis-feature-report>
              }
            </div>
          }
        }
      </div>
    }
  </div>
</dash-gis-flexible-panel>
